import { useAppConfigStore } from '@/stores/appConfig'

const APP_BIND_SCHEME = 'luckywallet://merchant/bind'

export function buildAppBindSchemeUrl(token?: string) {
  const params = new URLSearchParams({ action: 'third-bind' })
  if (token) {
    params.set('token', token)
  }
  return `${APP_BIND_SCHEME}?${params.toString()}`
}

/** 尝试唤起 APP，失败则跳转下载页 */
export function openAppOrDownloadPage(token?: string) {
  const schemeUrl = buildAppBindSchemeUrl(token)
  // 下载页 URL 从 APP 配置中获取
  const downloadPage =
    useAppConfigStore().config?.endpoints.landing || import.meta.env.VITE_APP_DOWNLOAD_PAGE

  if (!downloadPage) {
    window.location.href = schemeUrl
    return
  }

  const start = Date.now()
  let fallenBack = false

  const cleanup = () => {
    document.removeEventListener('visibilitychange', onVisibilityChange)
    window.clearTimeout(timer)
  }

  const fallback = () => {
    if (fallenBack) return
    fallenBack = true
    cleanup()
    window.location.href = downloadPage
  }

  const onVisibilityChange = () => {
    if (document.hidden) {
      cleanup()
    }
  }

  document.addEventListener('visibilitychange', onVisibilityChange)

  const timer = window.setTimeout(() => {
    if (!document.hidden && Date.now() - start < 3000) {
      fallback()
    } else {
      cleanup()
    }
  }, 2500)

  window.location.href = schemeUrl
}
